import React from 'react';

export const StatusBadge: React.FC<{
  status: string;
  onClick?: () => void;
}> = ({ status, onClick }) => {
  const cls = status === 'Activo'
    ? 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30'
    : status === 'Pendiente'
    ? 'bg-amber-500/15 text-amber-400 border-amber-500/30'
    : status === 'Completado'
    ? 'bg-blue-500/15 text-blue-400 border-blue-500/30'
    : status === 'Desviado'
    ? 'bg-red-500/15 text-red-400 border-red-500/30'
    : 'bg-gray-500/15 text-gray-400 border-gray-500/30';

  return (
    <button
      onClick={(e) => { e.stopPropagation(); onClick?.(); }}
      className={`text-xs font-bold px-2.5 py-1 rounded border transition-all hover:scale-105 ${cls} ${onClick ? 'cursor-pointer hover:brightness-125' : 'cursor-default'}`}
      title={onClick ? 'Clic para cambiar estado' : undefined}
    >
      {status}
    </button>
  );
};
